import React from "react";
import Footer from "../components/homepage/Footer";
import Navbar from "../components/homepage/Navbar";
import Picture from "../components/Houses/pictures";

const PicturesPage = () => {
  return (
    <div>
      <Navbar />
      <Picture />
      <Footer />
    </div>
  );
};

export default PicturesPage;
